/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import image from "./logo.svg";

const logoStyles = {
  display: "block",
  height: "60px",
  padding: 0,
};

function widget_logo({ classes = "" }) {
  return <img src={image} className={classes} style={logoStyles} />;
}

export default widget_logo;



// WEBPACK FOOTER //
// ./src/plugins/tfs/platformConfigs/widgets/widget_logo/index.js